import React, { FC } from 'react';
import { CustomButton } from '@mindly/ui-components';
import { IonIcon } from '@ionic/react';
import { checkmarkCircleOutline } from 'ionicons/icons';
import {
  SubscriptionActionModalText,
  SubscriptionActionModalTitle,
} from '../../CancelSubscriptionModal/CancelSubscriptionModal.style';
import { FormattedMessage } from 'react-intl';
import { ISubscription } from '../../../../redux/subscriptions/types';
import useLangs from '../../../../context/LangsContext';

type FinishStepProps = {
  handleClose: () => void;
  subscription?: ISubscription | null;
};

const FinishStep: FC<FinishStepProps> = ({ handleClose, subscription }) => {
  const { locale } = useLangs();

  if (!subscription) return null;

  return (
    <div className={'finish-step-wrapper'}>
      <IonIcon icon={checkmarkCircleOutline} />
      <SubscriptionActionModalTitle>
        <FormattedMessage id={'subscription.unpause.step.3.title'} defaultMessage={'Вашу підписку відновлено'} />
      </SubscriptionActionModalTitle>
      <SubscriptionActionModalText className={'cancel-text'}>
        <FormattedMessage id={'subscription.unpause.step.3.test'} defaultMessage={'Ваша наступна платіжна дата'} />{' '}
        <b>
          {new Date(+subscription?.period_end * 1000).toLocaleString(locale, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </b>
      </SubscriptionActionModalText>
      <CustomButton buttonType={'primary'} onClick={handleClose}>
        <FormattedMessage id={'general.good.btn'} defaultMessage={'Добре'} />
      </CustomButton>
    </div>
  );
};

export default FinishStep;
